import React, { useContext } from "react";
import Table from "../Shared/Table";

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button
} from "reactstrap";

import { settingsManagement } from "core/UrlEndpoints";
import { useHistory } from "react-router-dom";
import { UserContext } from "context/UserContext";

const SettingsList = () => {
  const history = useHistory();
  const { userHasAnyPermissions } = useContext(UserContext)

  return (
    <>
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Settings</CardTitle>

                {/* ONLY IF HAVE SPECIFIC PERMISSION */}
                {userHasAnyPermissions(["write:settingsManagement"]) &&
                  <Button
                    color="primary"
                    onClick={() => history.push(`settings/add`)}>
                    Add
                  </Button>
                }
              </CardHeader>
              <CardBody>
                <Table
                  url={settingsManagement}
                  columns={[
                    {
                      header: "Name",
                      accessorKey: "displayName",
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
      </Row>
    </>
  );
};

export default SettingsList;
